export const DEFAULT_LOCALE = "en";
export const LOCALE_STORAGE_KEY = "v2n_locale";

export const SUPPORTED_LOCALES = [
  { code: "en", label: "English", htmlLang: "en" },
  { code: "es", label: "Español", htmlLang: "es" },
  { code: "fr", label: "Français", htmlLang: "fr" },
  { code: "de", label: "Deutsch", htmlLang: "de" },
  { code: "nl", label: "Nederlands", htmlLang: "nl" },
  { code: "pl", label: "Polski", htmlLang: "pl" },
  { code: "sv", label: "Svenska", htmlLang: "sv" },
];

export const SUPPORTED_LOCALE_CODES = SUPPORTED_LOCALES.map((locale) => locale.code);

export function normalizeLocale(value) {
  const code = String(value || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_LOCALE_CODES.includes(code) ? code : DEFAULT_LOCALE;
}

function getSupportedBrowserLocale(value) {
  const code = String(value || "")
    .trim()
    .toLowerCase()
    .split("-")[0];

  return SUPPORTED_LOCALE_CODES.includes(code) ? code : null;
}

export function getStoredLocale(storage = typeof window !== "undefined" ? window.localStorage : null) {
  try {
    const stored = storage?.getItem(LOCALE_STORAGE_KEY);
    return stored ? normalizeLocale(stored) : null;
  } catch {
    return null;
  }
}

export function saveStoredLocale(locale, storage = typeof window !== "undefined" ? window.localStorage : null) {
  const normalized = normalizeLocale(locale);

  try {
    storage?.setItem(LOCALE_STORAGE_KEY, normalized);
  } catch {
    // Language selection should never block page navigation.
  }

  return normalized;
}

export function detectBrowserLocale(nav = typeof navigator !== "undefined" ? navigator : null) {
  const browserLanguages = Array.isArray(nav?.languages) ? nav.languages : [];
  const candidates = [...browserLanguages, nav?.language].filter(Boolean);

  for (const candidate of candidates) {
    const supported = getSupportedBrowserLocale(candidate);
    if (supported) {
      return supported;
    }
  }

  return DEFAULT_LOCALE;
}

export function resolveInitialLocale({
  storage = typeof window !== "undefined" ? window.localStorage : null,
  nav = typeof navigator !== "undefined" ? navigator : null,
} = {}) {
  return getStoredLocale(storage) || detectBrowserLocale(nav) || DEFAULT_LOCALE;
}

export function getLocaleDefinition(locale) {
  const normalized = normalizeLocale(locale);
  return SUPPORTED_LOCALES.find((item) => item.code === normalized) || SUPPORTED_LOCALES[0];
}
